module.exports = __webpack_public_path__ + "img/f615a3654f7e0a1c2c40a5bdcacaa022.png";